<script setup lang="ts">
withDefaults(defineProps<{
  orientation?: DividerOrientation
  size?: DividerSize
  variant?: DividerVariant
  noMargin?: boolean
}>(), {
  orientation: 'horizontal',
  size: 'small',
  variant: 'solid',
  noMargin: false,
})
</script>

<template>
  <div role="separator" :class="[orientation, variant, size, { 'no-margin': noMargin }]" />
</template>

<style scoped lang='postcss'>
div {
  @apply border-carbon-200 reading-dark:border-carbon-400;

  &.vertical {
    @apply min-h-4 w-fit;

    &:not(.no-margin) {
      @apply mx-2xs;

      &.medium {
        @apply mx-s;
      }

      &.large {
        @apply mx-m;
      }
    }
  }

  &.horizontal {
    @apply w-full;

    &:not(.no-margin) {
      @apply my-2xs;

      &.medium {
        @apply my-s;
      }

      &.large {
        @apply my-m;
      }
    }
  }

  &.dashed {
    @apply border-dashed;
  }

  &.dotted {
    @apply border-dotted;
  }

  &.solid {
    @apply border-solid;
  }

  &.small {
    @apply border-[0.5px];
  }

  &.medium {
    @apply border-[1px];
  }

  &.large {
    @apply border-[2px];
  }
}
</style>
